import { Link } from "react-router-dom";
import PublicShell from "../layout/PublicShell";

export default function NotFound() {
  return (
    <PublicShell minimal>
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <div
          className="font-serif text-[120px] md:text-[160px] leading-none text-paper-deep select-none"
          aria-hidden
        >
          4<span className="italic text-terracotta">¶</span>4
        </div>
        <h1 className="mt-4 font-serif text-3xl md:text-4xl leading-tight">
          That page is somewhere else now.
        </h1>
        <p className="mt-3 font-serif italic text-ink-soft text-base">
          Or we never made it. Either way, here's the door back.
        </p>
        <div className="mt-7 flex justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 rounded-md border border-ink/80 px-4 py-2 text-[13px] hover:bg-ink hover:text-paper transition-colors"
          >
            ← Home
          </Link>
          <Link
            to="/app/today"
            className="inline-flex items-center gap-1.5 rounded-md bg-terracotta text-paper px-4 py-2 text-[13px] hover:bg-terracotta-soft transition-colors"
          >
            Open dashboard →
          </Link>
        </div>
      </div>
    </PublicShell>
  );
}
